import { IEcsConfig } from "../core/slices/ecsSlice";
export const initialEcsConfig = process.env
  .INITIAL_ECS_CONFIG as unknown as IEcsConfig;
